import React from 'react';
import { CircleSpinner } from '..';
const Loading = ({ text = 'Loading...', noText = false, size = 60 }) => (React.createElement("div", { style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    } }, noText ? (React.createElement(CircleSpinner, { size: size })) : (React.createElement(React.Fragment, null,
    React.createElement("h4", null, text),
    React.createElement("br", null),
    React.createElement(CircleSpinner, { size: size })))));
export default Loading;
